import {CompetitionMatchesPageRouteMetaDataModel} from "./competition-matches-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionMatchesPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.matches,
      path: `matches`,
      componentImport: () => import("../components/competition-matches-page" /* webpackChunkName: "competition-matches-page" */ ),
      metadataType: CompetitionMatchesPageRouteMetaDataModel
    });
  }
}
